import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { routerReducer as routing } from 'react-router-redux';

import appState from '../initializers/initReducer';
import categories from '../../category/categoriesDucks';
import documents from '../../documents/documentsDucks';
import document from '../../document/documentDucks';
import links from '../../links/linksDucks';
import login from '../../login/loginDucks';
import news from '../../news/newsDucks';
import roadmap from '../../roadmap/roadmapDucks';
import modal from '../components/modal/modalDucks';
import message from '../components/message/messageDucks';
import search from '../../search/searchDucks';
import securityContext from '../security/authDucks';

export default combineReducers({
  appState,
  categories,
  documents,
  document,
  form: formReducer,
  links,
  login,
  message,
  news,
  roadmap,
  modal,
  routing,
  search,
  securityContext,
});



// WEBPACK FOOTER //
// ./book/src/commons/reducers/rootReducer.js